import React, { useMemo } from 'react';

import { WorkoutBlockType } from '../../constants/enums';
import {
  BlockResultsTable,
  BlockResultsTH,
  BlockResultsRow,
  BlockResultsTD,
  HoverIndicator,
  NoResults,
} from './components';

const ResultTable = ({ block }) => {
  console.log(block, '----');
  const hasNewRunFormat = block?.type === WorkoutBlockType.RUN && block?.results?.[0]?.value?.length >= 2;

  const [setOrRoundAttr, blockRows] = useMemo(
    () => [
      block?.type === WorkoutBlockType.RFT
        ? { name: 'total times', value: 1 }
        : block?.type === WorkoutBlockType.AMRAP
        ? { name: 'Total Number of Roundss', value: 1 }
        : block?.type === WorkoutBlockType.RUN
        ? {
            name: 'Times',
            value: 1,
          }
        : block?.type === WorkoutBlockType.PILATESR
        ? { name: 'Reps', value: 1 }
        : block?.customAttributes?.find((x) => x.name === 'sets' || x.name === 'rounds') || {
            name: 'times',
            value: 1,
          },
      block?.type === WorkoutBlockType.STRENGTH
        ? [block?.exercises?.[0]]
        : block?.type === WorkoutBlockType?.RUN
        ? hasNewRunFormat
          ? block?.exercises
          : [{ exercise: { title: 'Total Time' } }]
        : block?.exercises,
    ],
    [block, hasNewRunFormat],
  );

  const arrayofHeadings = useMemo(() => new Array(setOrRoundAttr.value).fill(1), [setOrRoundAttr]);
  return (
    <>
      {!block?.results?.[0]?.value?.length ? (
        <NoResults>No Results Yet</NoResults>
      ) : (
        <BlockResultsTable
          style={block?.type === WorkoutBlockType.AMRAP ? { width: 'fit-content' } : {}}
        >
          <thead>
            <BlockResultsTH></BlockResultsTH>
            {block?.type !== WorkoutBlockType.AMRAP && <BlockResultsTH>Name</BlockResultsTH>}
            {hasNewRunFormat ? (
              <>
                <BlockResultsTH>Time</BlockResultsTH>
                <BlockResultsTH>Distance (km)</BlockResultsTH>
              </>
            ) : (
              arrayofHeadings?.map((heading, j) => (
                <BlockResultsTH>{
                  block?.type === WorkoutBlockType.PILATESR
                    ? 'Reps'
                    : `${setOrRoundAttr?.name?.substr(
                        0,
                        setOrRoundAttr?.name?.length - 1,
                      )} ${
                        ((setOrRoundAttr?.name === 'rounds' || setOrRoundAttr?.name === 'sets') && j + 1) ||
                        ''
                      }`
                }</BlockResultsTH>
              ))
            )}
          </thead>
          <tbody>
            {block?.type === WorkoutBlockType.AMRAP ? (
              <BlockResultsRow>
                <BlockResultsTD>
                  <HoverIndicator className="hover_indicator" />
                </BlockResultsTD>
                <BlockResultsTD style={{ textAlign: 'center' }}>
                  {`${block?.results?.[0]?.value?.[0]?.[0]}` || '-'}
                </BlockResultsTD>
              </BlockResultsRow>
            ) : block?.type === WorkoutBlockType.RFT ? (
              block?.results?.[0]?.value?.map((round, row) => (
                <BlockResultsRow>
                  <BlockResultsTD>
                    <HoverIndicator className="hover_indicator" />
                  </BlockResultsTD>
                  <BlockResultsTD>
                    {`${block?.customAttributes?.find((x) => x.name === 'rounds')?.value} Rounds`}
                  </BlockResultsTD>
                  <BlockResultsTD>
                    {`${('0' + Math.floor(round?.[0] / 60)).slice(-2)}:${(
                      '0' +
                      (round?.[0] % 60)
                    ).slice(-2)}` || '-'}
                  </BlockResultsTD>
                </BlockResultsRow>
              ))
            ) : hasNewRunFormat ? (
              blockRows?.map((exercise, row) => {
                const timeSecs = block?.results?.[0]?.value?.[0]?.[row] || 0;
                const distKm = block?.results?.[0]?.value?.[1]?.[row] || 0;
                const timeFormatted = `${('0' + Math.floor(timeSecs / 60)).slice(-2)}:${(
                  '0' + (Math.round(timeSecs) % 60)
                ).slice(-2)}`;
                return (
                  <BlockResultsRow key={row}>
                    <BlockResultsTD>
                      <HoverIndicator className="hover_indicator" />
                      {row + 1}
                    </BlockResultsTD>
                    <BlockResultsTD>{exercise?.exercise?.title}</BlockResultsTD>
                    <BlockResultsTD>{timeFormatted}</BlockResultsTD>
                    <BlockResultsTD>{distKm ? `${distKm} km` : '-'}</BlockResultsTD>
                  </BlockResultsRow>
                );
              })
            ) : (
              blockRows?.map((exercise, row) => (
                <BlockResultsRow>
                  <BlockResultsTD>
                    <HoverIndicator className="hover_indicator" />
                    {block?.type !== WorkoutBlockType?.RUN && row + 1}
                  </BlockResultsTD>
                  <BlockResultsTD>{exercise?.exercise?.title}</BlockResultsTD>
                  {arrayofHeadings?.map((a, col) => (
                    <BlockResultsTD>
                      {block?.type === WorkoutBlockType.STRENGTH
                        ? block?.results?.[0]?.value?.length > 1
                          ? `${block?.results?.[0]?.value?.[1]?.[col]}kg (${block?.results?.[0]?.value?.[0]?.[col]} reps)`
                          : block?.results?.[0]?.value?.[0]?.[col] + 'kg'
                        : block?.type === WorkoutBlockType.CLASSICSTRENGTH
                        ? `${block?.results?.[0]?.value?.[1]?.[row]}kg (${block?.results?.[0]?.value?.[0]?.[row]} reps)`
                        : block?.type === 'SUPERSETS'
                        ? arrayofHeadings?.length &&
                          block?.results?.[0]?.value?.[col + arrayofHeadings?.length]?.[row]
                          ? `${
                              block?.results?.[0]?.value?.[col + arrayofHeadings?.length]?.[row]
                            }kg (${block?.results?.[0]?.value?.[col]?.[row]}reps)`
                          : block?.results?.[0]?.value?.[col]?.[row] + 'reps'
                        : block?.type === WorkoutBlockType?.RUN
                        ? `${(
                            '0' + Math.floor(block?.results?.[0]?.value?.[col]?.[row] / 60)
                          ).slice(-2)}:${(
                            '0' +
                            (block?.results?.[0]?.value?.[col]?.[row] % 60)
                          ).slice(-2)}`
                        : block?.type === WorkoutBlockType.PILATESR
                        ? `${block?.results?.[0]?.value?.[0]?.[row] || 0} reps`
                        : block?.results?.[0]?.value?.[col]?.[row] || '-'}
                    </BlockResultsTD>
                  ))}
                </BlockResultsRow>
              ))
            )}
          </tbody>
        </BlockResultsTable>
      )}
    </>
  );
};

export default ResultTable;
